import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_ICON_BUTTON_CLASS_NAME = 'ActionMenuIconButton';
export const ACTION_MENU_ICON_BUTTON_CLASS_SLOTS = [
	'root',
	'menu',
	'skeleton',
] as const;

export type ActionMenuIconButtonClassSlot =
	(typeof ACTION_MENU_ICON_BUTTON_CLASS_SLOTS)[number];

export interface ActionMenuIconButtonClasses {
	root: string;
	menu: string;
	skeleton: string;
	smallScreen: string;
	fab: string;
	icon: string;
}

export type ActionMenuIconButtonClassKey = keyof ActionMenuIconButtonClasses;

export const getActionMenuIconButtonUtilityClass = (slot: string) =>
	generateUtilityClass(ACTION_MENU_ICON_BUTTON_CLASS_NAME, slot);

export const actionMenuIconButtonClasses = generateUtilityClasses<
	keyof ActionMenuIconButtonClasses
>(ACTION_MENU_ICON_BUTTON_CLASS_NAME, [
	'root',
	'menu',
	'skeleton',
	'smallScreen',
	'fab',
	'icon',
]);
export default actionMenuIconButtonClasses;
